define.alias("shared/components/shared/publish/switcher/item/publish-method", "media/components/shared/publish/switcher/item/publish-method");